import * as React from 'react';

const Novolume = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M18.9145 12.0802C19.196 12.2155 19.375 12.5002 19.375 12.8125V27.9792C19.375 28.2915 19.196 28.5762 18.9145 28.7115C18.633 28.8468 18.2988 28.8087 18.0549 28.6136L12.8608 24.4583H8.8125C8.36377 24.4583 8 24.0946 8 23.6458V17.1458C8 16.6971 8.36377 16.3333 8.8125 16.3333H12.8608L18.0549 12.1781C18.2988 11.9829 18.633 11.9449 18.9145 12.0802ZM17.75 14.503L13.6534 17.7803C13.5093 17.8956 13.3303 17.9583 13.1458 17.9583H9.625V22.8333H13.1458C13.3303 22.8333 13.5093 22.8961 13.6534 23.0114L17.75 26.2887V14.503ZM24.488 16.5713C24.8053 16.254 25.3197 16.254 25.637 16.5713L28.3125 19.2468L30.988 16.5713C31.3053 16.254 31.8197 16.254 32.137 16.5713C32.4543 16.8886 32.4543 17.4031 32.137 17.7204L29.4615 20.3958L32.137 23.0713C32.4543 23.3886 32.4543 23.9031 32.137 24.2204C31.8197 24.5377 31.3053 24.5377 30.988 24.2204L28.3125 21.5449L25.637 24.2204C25.3197 24.5377 24.8053 24.5377 24.488 24.2204C24.1707 23.9031 24.1707 23.3886 24.488 23.0713L27.1635 20.3958L24.488 17.7204C24.1707 17.4031 24.1707 16.8886 24.488 16.5713Z"
      fill="#121212"
    />
  </svg>
);
export default Novolume;
